import {depositConstants} from '@cibsite/ui-components-vue2';

import {depositSlide} from '@/core/models/common/MainSliderSlides/Individuals/IndividualsSlidesModel';
import {
    greenDepositSlide,
    // newComfortDepositSlide,
    newComfortDepositSlideHypotises,
    euroDepositSlide,
    premiumDepositSlide,
    m4DepositSlide,
    mortgageDepositSlide,
    demandDepositSlide,
    exclusiveDepositSlide,
    cumulativeDepositSlide,
    winterDepositSlide,
    seasonDepositSlide,
} from '@/core/models/common/OfferSliderSlides/ForIndividuals/DepositsSlidesModel';
import {
    universalDepositsSlideHypotises,
    premiumDepositsSlide,
    // universalDepositsSlide,
    winterDepositsSlide,
} from '@/core/models/common/MainSliderSlides/HomePage/HomePageSlidesModel';

const {DEPOSITS_TYPES_BY_OPENING_PLACE, DEPOSITS_TYPES} = depositConstants;

const slidesData = [
    universalDepositsSlideHypotises,
    winterDepositsSlide,
    // universalDepositsSlide,
    premiumDepositsSlide,
    depositSlide,
];

const offerTabsData = [
    {
        label: 'рублевые',
        slotName: 'rubDeposits',
    },
];

const rubDeposits = [
    newComfortDepositSlideHypotises,
    winterDepositSlide,
    // newComfortDepositSlide,
    exclusiveDepositSlide,
    premiumDepositSlide,
    cumulativeDepositSlide,
    greenDepositSlide,
    m4DepositSlide,
    demandDepositSlide,
    mortgageDepositSlide,
    seasonDepositSlide,
];

const currDeposits = [
    euroDepositSlide,
];

const depositsServices = [
    {
        title: 'Заказ справки о&nbsp;состоянии счета вклада',
        link: 'https://www.centrinvest.ru/cabinet/depobalance/',
        buttonLabel: 'Заказать справку',
    },
    {
        title: 'Заказ справок по&nbsp;всем открытым счетам госслужащим для заполнения декларации',
        link: 'https://www.centrinvest.ru/cabinet/allopenaccounts/',
        buttonLabel: 'Заказать справку',
    },
    {
        title: 'Предварительная запись <br/> на посещение офиса',
        link: 'https://www.centrinvest.ru/cabinet/remote-recording/unit',
        buttonLabel: 'Записаться',
    },
];

const infoTabsData = [
    {
        label: 'Необходимые документы',
        slotName: 'docs',
    },
    {
        label: 'Правила и тарифы',
        slotName: 'references',
    },
    {
        label: 'Условия пролонгации',
        slotName: 'prolongations',
    },
];

const rubProlongationsTableData = {
    thead: [
        'Виды вкладов', 'Вид вклада после пролонгации / Процентная ставка (% годовых)',
    ],
    tbody: [
        {
            row: [
                {
                    td: `
                            &laquo;Расти большой&raquo; (для вкладов, открытых c&nbsp;27.11.2014 до&nbsp;20.07.2016; для
                            вкладов от&nbsp;3&nbsp;млн. руб., открытых с&nbsp;01.11.2018 по&nbsp;07.02.2019,
                            с&nbsp;01.06.2020 по&nbsp;14.07.2020)
                        `,
                },
                {
                    td: 'ставка устанавливается в размере, равном ключевой ставке ЦБ РФ',
                },
            ],
        },
        {
            row: [
                {
                    td: `
                            &laquo;Расти большой&raquo; (для вкладов, открытых c&nbsp;20.07.2016 до&nbsp;17.01.2017)
                        `,
                },
                {
                    td: 'ставка устанавливается в размере, равном <strong>4/5</strong> ключевой ставки ЦБ РФ',
                },
            ],
        },
        {
            row: [
                {
                    td: `
                            &laquo;Расти большой&raquo; (для вкладов, условиями договора которых была предусмотрена
                            пролонгация под процентную ставку, действующую в&nbsp;банке по&nbsp;данному виду вклада
                            на&nbsp;день пролонгации)
                        `,
                },
                {
                    td: '<strong>8%</strong>',
                },
            ],
        },
        {
            row: [
                {
                    td: `
                            &laquo;Пенсионный накопительный на 1 год&raquo; с правом добавления/снятия
                        `,
                },
                {
                    td: `
                            &mdash;&nbsp;для договоров, по&nbsp;которым в&nbsp;течение периода, предыдущего
                            дате пролонгации (1&nbsp;год), по&nbsp;счету вклада осуществлялись клиентские
                            расчетные операции, договор пролонгируется на&nbsp;действующих условиях автоматической
                            пролонгации с&nbsp;установленной процентной ставкой в&nbsp;размере <strong>3,3%</strong>
                            годовых;<br/>
                            &mdash;&nbsp;для договоров, по&nbsp;которым в&nbsp;течение периода, предшествующего дате
                            пролонгации (1&nbsp;год), отсутствовали клиентские расчетные операции по&nbsp;счету вклада,
                            договор пролонгируется на&nbsp;условия вклада &laquo;до&nbsp;востребования&raquo;.
                        `,
                },
            ],
        },
    ],
};

const infoDocs = [
    {
        title: 'Гражданам РФ',
        docs: [
            'Документ, удостоверяющий личность гражданина.',
            'Свидетельство о&nbsp;постановке на&nbsp;учет в&nbsp;налоговом органе (ИНН).',
            'Страховое свидетельство (СНИЛС).',
        ],
    },
    {
        title: 'Иностранным гражданам',
        docs: [
            'Документ, удостоверяющий личность гражданина;',
            'Свидетельство о&nbsp;постановке на&nbsp;учет в&nbsp;налоговом органе (ИНН или его аналог);',
            'Миграционную карту;',
            'Документ, подтверждающий право на&nbsp;пребывание (проживание) в&nbsp;РФ.',
            'Анкету самосертификации (для иностранного гражданина — нерезидента)',
            'Документ, удостоверяющий личность гражданина, должен содержать следующие сведения:',
        ],
        appendix: [
            'фамилию, имя и (если иное не вытекает из закона или национального обычая) отчество;',
            'дату и&nbsp;место рождения;',
            'гражданство;',
            `
                реквизиты документа, удостоверяющего личность: серия и&nbsp;номер документа, дата выдачи
                документа, наименование органа, выдавшего документ, и&nbsp;код подразделения (если имеется);
            `,
            'адрес места жительства (регистрации) или места пребывания.',
        ],
        note: [
            'Для заключения договора банковского вклада в&nbsp;банк предъявляются оригиналы документов.',
            'Все предъявляемые документы должны быть действительными на&nbsp;дату их&nbsp;предъявления.',
            'Документы иностранных граждан должны иметь перевод на&nbsp;русский язык.',
        ],
    },
];

const depositsTemplates = [
    {
        label: 'Памятка по валютным ограничениям',
        link: '/files/services/fiz/pdf/memo.pdf',
    },
    {
        label: 'Текущий банковский счет',
        link: '/files/services/fiz/doc/tekushii_bank_schet.docx',
    },
    {
        label: 'Правила обслуживания банковских вкладов физических лиц в&nbsp;ПАО КБ&nbsp;&laquo;Центр-инвест&raquo;',
        link: '/media/fiz/deposits/documents/pdf/pravila_obsluzhivaniya_bankovskih_vkladov_FL_22.01.2024.pdf',
    },
    {
        label: 'Сборник условий по&nbsp;банковским вкладам физических лиц ПАО &laquo;Центр-инвест&raquo;',
        link: '/media/fiz/deposits/documents/pdf/sbornik-yslovii-po-vkladam.pdf',
    },
    {
        label: 'Заявление о&nbsp;размещении банковского вклада',
        link: '/media/fiz/deposits/documents/pdf/tipovaya_forma_zayavleniya_o_razmeshenii_bankovskogo_vklada.pdf',
    },
];

const depositsAdvantages = [
    {
        iconSrc: 'icons/advantages/deposits-advantage_1.svg',
        description: 'Честный процент',
    },
    {
        iconSrc: 'icons/advantages/deposits-advantage_2.svg',
        description: 'Прозрачные условия',
    },
    {
        iconSrc: 'icons/advantages/deposits-advantage_3.svg',
        description: 'Без дополнительных обязательств и&nbsp;страховок',
    },
];

const officeTabsData = [
    {
        label: 'Офис',
        slotName: DEPOSITS_TYPES_BY_OPENING_PLACE.OFFLINE,
    },
    {
        label: 'Онлайн',
        slotName: DEPOSITS_TYPES_BY_OPENING_PLACE.ONLINE,
    },
    {
        label: 'Онлайн для Клиентов',
        slotName: DEPOSITS_TYPES_BY_OPENING_PLACE.ONLINE_FOR_CLIENTS,
    },
];

const stepTabsData = [
    {
        label: 'Онлайн',
        slotName: DEPOSITS_TYPES_BY_OPENING_PLACE.ONLINE,
    },
    {
        label: 'Офис',
        slotName: DEPOSITS_TYPES_BY_OPENING_PLACE.OFFLINE,
    },
];

const depositOfficeInitialActiveTab = [
    {
        slug: DEPOSITS_TYPES.UNIVERSAL,
        activeTab: DEPOSITS_TYPES_BY_OPENING_PLACE.ONLINE_FOR_CLIENTS,
    },
];

export {
    slidesData,
    offerTabsData,
    rubDeposits,
    currDeposits,
    depositsServices,
    infoTabsData,
    infoDocs,
    rubProlongationsTableData,
    depositsTemplates,
    depositsAdvantages,
    officeTabsData,
    stepTabsData,
    depositOfficeInitialActiveTab,
};
